/* eslint-disable @angular-eslint/no-output-rename */
/* eslint-disable @angular-eslint/no-input-rename */
import { animate, style, transition, trigger } from '@angular/animations';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AsyncPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, interval, of } from 'rxjs';
import { concatMap, filter, takeUntil, tap } from 'rxjs/operators';
import { WindowVisibilityService } from '../../../../services/window-visibility.service';
import { isNullOrUndefined } from '../../../../shared/adv-utils';
import { YsCarouselImageComponent } from '../ys-carousel-image/ys-carousel-image.component';
import { SwipeStart, YsCarouselAnimation, YsCarouselClickedEvent, YsCarouselConfig, YsCarouselState, YsCarouselTile, YsCarouselTileInternal, initialYsDiaShowConfig } from '../ys-carousel/ys-carousel.model';


/**
 * YsDiaShowComponent
 * - This component is similar to the YsCarouselComponent.
 * - But the purpose is different. It is intended to be used for displaying a dia show with hundreds of images (tiles).
 * - This something, the carousel component is not intended to do.
 * - To fulfill this purpose, the component sues a different memory management strategy and a different animation strategy.
 * - We have one stage with one tile. The tile is animated to the left or right.
 */
@UntilDestroy()
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ys-dia-show',
  imports: [
    AsyncPipe,
    MatProgressBarModule,
    MatButtonModule,
    MatIconModule,
    YsCarouselImageComponent
  ],
  templateUrl: './ys-dia-show.component.html',
  styleUrl: './ys-dia-show.component.scss',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  // animations: [
  //   trigger('flyInOut', [
  //     state('in', style({ transform: 'translateX(0)' })),
  //     transition('void => *', [
  //       style({ transform: 'translateX(-100%)' }),
  //       animate(300)
  //     ]),
  //     transition('* => void', [
  //       animate(300, style({ transform: 'translateX(100%)' }))
  //     ])
  //   ])
  // ]
  animations: [
    trigger('flyInOut', [
      transition(':enter, * => 0, * => -1', []),
      transition(':increment', [
        style({ transform: 'translateX(100%)' }),
        animate(300)
        // query(':enter', [
        //   style({ opacity: 0, width: 0 }),
        //   stagger(50, [
        //     animate('300ms ease-out', style({ opacity: 1, width: '*' })),
        //   ]),
        // ], { optional: true })
      ]),
      transition(':decrement', [
        style({ transform: 'translateX(-100%)' }),
        animate(300)
        // query(':leave', [
        //   stagger(50, [
        //     animate('300ms ease-out', style({ opacity: 0, width: 0 })),
        //   ]),
        // ])
      ]),
    ]),
  ]
})
export class YsDiaShowComponent implements OnInit, AfterViewInit {
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly windowVisibilityService = inject(WindowVisibilityService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly elementRef = inject(ElementRef);

  @Input('config') configInput: YsCarouselConfig | null = null;
  @Input('repo') repo: string | null = null;
  @Input('tiles') tilesInput: YsCarouselTile[] = [];
  @Output('clicked') carouselClicked: EventEmitter<YsCarouselClickedEvent> = new EventEmitter();

  public config: YsCarouselConfig = { ...initialYsDiaShowConfig }
  public tiles: YsCarouselTileInternal[] = [];
  public animation$: BehaviorSubject<YsCarouselAnimation | null> = new BehaviorSubject<YsCarouselAnimation | null>(null);

  /**
   * Behavior subject to control the current index with in the array of tiles
   */
  public index$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  /**
   * Reference to the carousel container HTML element (outer)
   */
  @ViewChild('carouselContainer') carouselContainer?: ElementRef;

  /**
   * Reference to the CdkScrollable
   */
  @ViewChild(CdkVirtualScrollViewport) cdkScrollable?: CdkVirtualScrollViewport;



  /**
   * Width in px of the carousel container (inner) on start on initialization
   * - it is initially set zo 0
   * - it is set to the actual width of the carousel container (inner) when the carousel is initialized
   * - it is used to calculate the width of the carousel container (inner) when the window is resized
   * - it is an important input parameter
   */
  public carouselWidth: number = 0;

  // state
  public state$: BehaviorSubject<YsCarouselState> = new BehaviorSubject<YsCarouselState>(YsCarouselState.NOT_PLAYING);
  //public slidePercent: number = 0;


  // public runningInner$ = of(null).pipe(
  //   tap(res => {
  //     const currentIdx = this.index$.getValue();
  //     if (currentIdx === -1) {
  //       this.index$.next(0);
  //     } else if (currentIdx < this.tiles.length) {
  //       this.index$.next(currentIdx + 1);
  //     } else {
  //       this.index$.next(0);
  //     }
  //   })
  // );
  // // Observable running the presentation initially
  // public runningInitial$ = interval(this.config.presentationTimeMs).pipe(
  //   filter(() => this.windowVisibilityService.visibilityState() === 'visible'),
  //   concatMap(res => this.runningInner$)
  // );


  // // Observable running the presentation after restart
  // public runningRestart$ = interval(this.config.presentationTimeMs).pipe(
  //   startWith(0),
  //   concatMap(res => this.runningInner$)
  // );
  // public subRunning = null;


  /**
   * Swipe status
   */
  private lastSwipeStart: SwipeStart | null = null;

  ngOnInit() {
    this.carouselWidth = this.elementRef.nativeElement.clientWidth;
    // configuration
    if (!isNullOrUndefined(this.configInput)) {
      this.config = {
        ...this.config,
        autoplay: !isNullOrUndefined(this.config.autoplay) ? this.config.autoplay : initialYsDiaShowConfig.autoplay,
        transitionTimeMs: !isNullOrUndefined(this.config.transitionTimeMs) ? this.config.transitionTimeMs : initialYsDiaShowConfig.transitionTimeMs,
        presentationTimeMs: !isNullOrUndefined(this.config.presentationTimeMs) ? this.config.presentationTimeMs : initialYsDiaShowConfig.presentationTimeMs,
        progressIndicator: !isNullOrUndefined(this.config.progressIndicator) ? this.config.progressIndicator : initialYsDiaShowConfig.progressIndicator,
        pagination: !isNullOrUndefined(this.config.pagination) ? this.config.pagination : initialYsDiaShowConfig.pagination,
        controls: !isNullOrUndefined(this.config.controls) ? this.config.controls : initialYsDiaShowConfig.controls,
        playButton: !isNullOrUndefined(this.config.playButton) ? this.config.playButton : initialYsDiaShowConfig.playButton,
        onClickPausePresentation: !isNullOrUndefined(this.config.onClickPausePresentation) ? this.config.onClickPausePresentation : initialYsDiaShowConfig.onClickPausePresentation,
      }
    }
    // tiles
    if (this.tilesInput && this.tilesInput.length > 0) {
      this.tiles = this.tilesInput.map(tile => ({
        styleClass: tile.styleClass,
        src: tile.img?.src,
        // width: tile.img.width,
        // height: tile.img.height,
        alt: tile.img?.alt ? tile.img.alt : 'TILE',
        // style: tile.img.style ? tile.img.style : `object-fit:cover;object-position:${tile.img.objectPosition ?? '50% 50%'};`,
        style: `object-fit:contain;object-position:${tile.img?.objectPosition ?? '50% 50%'};`,
        class: tile.img?.class,
        // srcset: tile.img.srcset?.join(',') ?? this.createImgSrcSet(tile.img.src, tile.img.breakpoints),
        sizes: tile.img?.sizes?.join(','),
        loading: tile.img?.loading,
        priority: tile.img?.priority,
        // fill: tile.img.fill,
        crossOrigin: 'anonymous',
        safeHtml: this.domSanitizer.bypassSecurityTrustHtml(tile.html ? tile.html : '')
      }));
    }

    /**
     * start the presentation
     * - this pipeline encapsulates the complete presentation logic
     */
    this.state$.pipe(
      untilDestroyed(this),
      filter(() => this.windowVisibilityService.visibilityState() === 'visible'),
      concatMap(state => {
        switch (state) {
          case YsCarouselState.PLAYING:
            return interval(this.config.presentationTimeMs).pipe(
              takeUntil(this.state$.pipe(filter(state => state !== YsCarouselState.PLAYING))),
              tap(() => this.index$.next(this.nextRightIndex()))
            );
          case YsCarouselState.PAUSED:
          case YsCarouselState.NOT_PLAYING:
            return of(null);
        }
      })
    ).subscribe();
  }

  ngAfterViewInit() {
    if (this.tiles.length > 1 && this.config.autoplay === true) {
      this.state$.next(YsCarouselState.PLAYING);
    }
  }

  // ngOnDestroy() {
  //   if (!isNullOrUndefined(this.subRunning)) {
  //     this.subRunning.unsubscribe();
  //     this.subRunning = null;
  //   }
  // }

  /**
   * click handler
   */
  clicked() {
    /** when state is PLAYING and this.config.onClickPausePresentation === true, pause the presentation */
    if (this.state$.getValue() === YsCarouselState.PLAYING && this.config.onClickPausePresentation === true) {
      this.state$.next(YsCarouselState.PAUSED);
    }
    // if (!isNullOrUndefined(this.subRunning) && this.config.onClickPausePresentation === true) {
    //   this.subRunning.unsubscribe();
    //   this.subRunning = null;
    // }
    // switch (this.state) {
    //   case YsCarouselState.PLAYING:
    //     if (this.config.onClickPausePresentation === true) {
    //       this.state = YsCarouselState.PAUSED;
    //     }
    //     break;
    //   case YsCarouselState.PAUSED:
    //     console.log ('clicked: ', this.state);
    //     this.subRunning = this.runningRestart$.subscribe();
    //     break;
    //   case YsCarouselState.NOT_PLAYING:
    //     break;
    // }
    // let idx = (this.index$.value >= this.tilesInput.length) ? this.index$.value - 1 : this.index$.value;
    // this.carouselClicked.emit({
    //   index: idx,
    //   tile: { ...this.tilesInput[idx] },
    //   state: this.state
    // })
  }

  /**
   * play the carousel
   */
  play() {
    /** move to next right tile */
    this.index$.next(this.nextRightIndex());
    /** continue presentation */
    this.state$.next(YsCarouselState.PLAYING);
  }

  /**
   * move to next left tile
   */
  left() {
    /** pause presentation */
    this.state$.next(YsCarouselState.PAUSED);
    /** move to next left tile */
    this.index$.next(this.nextLeftIndex());
  }


  /**
   * move to next right tile
   */
  right() {
    /** pause presentation */
    this.state$.next(YsCarouselState.PAUSED);
    /** move to next right tile */
    this.index$.next(this.nextRightIndex());
  }

  /**
   * move to a particular tile by index
   * @param idx 
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  moveTo(idx: number) {
    // //this.logService.log ('moveTo: ', idx)
    // if (idx !== this.index) {
    //   if (!isNullOrUndefined(this.subRunning)) {
    //     this.subRunning.unsubscribe();
    //     this.subRunning = null;
    //   }
    //   if (this.state === YsCarouselState.PLAYING) {
    //     this.state = YsCarouselState.PAUSED;
    //   }
    //   if (idx < this.tiles.length) {
    //     this.animation$.next({
    //       ...this.animData(this.animation$.getValue()),
    //       value: (idx) + '',
    //       params: {
    //         ...this.animData(this.animation$.getValue()).params,
    //         index: idx,
    //         sliderPositionPercent: ((idx) / (this.tiles.length + 1)) * 100,
    //       }
    //     })
    //     this.index = idx;
    //   }
    // }
  }


  /**
   * swipe handler
   */
  swipe(e: TouchEvent, what: string): void {
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();
    if (what === 'start') {
      this.lastSwipeStart = { coord, time };
    } else if (what === 'end' && this.lastSwipeStart) {
      const direction = [coord[0] - this.lastSwipeStart.coord[0], coord[1] - this.lastSwipeStart.coord[1]];
      const duration = time - this.lastSwipeStart.time;
      if (duration < 1000 //
        && Math.abs(direction[0]) > 30 // Long enough
        && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
        const swipe = direction[0] < 0 ? 'next' : 'previous';
        // tslint:disable-next-line: no-console
        //this.logService.info(swipe);
        if (swipe === 'next') {
          this.right();
        } else if (swipe === 'previous') {
          this.left();
        }
      }
    }
  }

  /**
   * private method to determine the next right index
   */
  private nextRightIndex(): number {
    if ((this.index$.value + 1) < this.tiles.length) {
      return this.index$.value + 1;
    } else {
      return 0;
    }
  }
  /**
   * private method to determine the next right index
   */
  private nextLeftIndex(): number {
    if ((this.index$.value - 1) < 0) {
      return this.tiles.length >= 1 ? this.tiles.length - 1 : 0;
    } else {
      return this.index$.value - 1;
    }
  }

  /**
   * animation data production
   * @param data 
   * @returns 
   */
  // animData(data: YsCarouselAnimation | null): void { //YsCarouselAnimation {
  //   // if (!isNullOrUndefined(data)) {
  //   //   return {
  //   //     value: !isNullOrUndefined(data.value) ? data.value : (this.index) + '',
  //   //     params: !isNullOrUndefined(data.params) ? data.params : this.animData(null).params
  //   //   }
  //   // } else {
  //   //   return {
  //   //     value: (this.index) + '',
  //   //     params: {
  //   //       sliderPositionPercent: (this.index / (this.tiles.length + 1)) * 100,
  //   //       index: this.index,
  //   //       tileCount: this.tiles.length,
  //   //       transitionTimeMs: this.config.transitionTimeMs,
  //   //     }
  //   //   }
  //   // }
  // }



  // public onImgLoading(loading: boolean, idx: number) {
  //   this.logService.log('loading: ', loading, ' idx: ', idx);
  //   setTimeout(() => {
  //     this.imageLoadingStatus[idx] = loading;
  //     this.logService.log('imageLoadingStatus: ', this.imageLoadingStatus)
  //     const combinedLoadingStatus = Object.keys(this.imageLoadingStatus).some(key => (this.imageLoadingStatus[key] === true));
  //     if (combinedLoadingStatus !== this.loadingSpinner$.getValue()) {
  //       this.loadingSpinner$.next(loading);
  //     }
  //   }, 0);
  // }



  /**
   * private method to create img srcset rules based on image breakpoints and image source.
   * @param src image source attribute of the tile
   * @param breakpoints optional array of breakpoints to be used instead of default breakpoints
   * @returns srcset rules
   */
  // private createImgSrcSet(src: string, breakpoints?: number[]): string {
  //   if (!isNullOrUndefined(breakpoints)) {
  //     return breakpoints.map(width => `${imageLoader({ width, src })} ${width}w`).join(',');
  //   } else {
  //     return IMAGE_BREAKPOINTS.map(width => `${imageLoader({ width, src })} ${width}w`).join(',');
  //   }
  // }
}